import React, { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "store/auth";
import { RecoilRoot } from "recoil";

import { StyledEngineProvider } from "@mui/material/styles";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 0, refetchOnWindowFocus: false }
  }
});

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <AuthProvider>
      <RecoilRoot>
        <QueryClientProvider client={queryClient}>
          <StyledEngineProvider injectFirst>
            <BrowserRouter>{children}</BrowserRouter>
          </StyledEngineProvider>
        </QueryClientProvider>
      </RecoilRoot>
    </AuthProvider>
  );
};

export default Providers;
